export default __webpack_public_path__ + "7744b045a2cbc0a7b9c5c5e523e5a5b2.png";